import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class OutingIterationQueryFilter extends QueryFilter{
    public outingId?: string;
    public isSubset: boolean;
}